import {
    FILTER_OPTIONS_REQUEST,
    FILTER_OPTIONS_SUCCESS,
    FILTER_OPTIONS_FAIL
} from '../constants/filterOptionsConstants';

/**
 * Reducer for filter options (LGAs, Categories, Zones).
 * Stores pre-fetched dropdown options to avoid repeated API calls.
 */
export const filterOptionsReducer = (state = { lgas: [], categories: [], zones: [] }, action) => {
    switch (action.type) {
        case FILTER_OPTIONS_REQUEST:
            return { loading: true, lgas: [], categories: [], zones: [] };

        case FILTER_OPTIONS_SUCCESS:
            return {
                loading: false,
                lgas: action.payload.lgas,
                categories: action.payload.categories,
                zones: action.payload.zones || []
            };

        case FILTER_OPTIONS_FAIL:
            return {
                loading: false,
                error: action.payload,
                lgas: [],
                categories: [],
                zones: []
            };

        default:
            return state;
    }
};
